
import React from "react";
import "./PageStyles.css";

function UserInfo() {
  const user = {
    name: "Tushar Chaudhari",
    age: 26,
    dob: "1998-08-12",
    email: "tush@example.com",
    phone: "+91 98765 43210",
    role: "Sr Software Engineer",
    location: "Pune, India",
    image: "https://randomuser.me/api/portraits/men/32.jpg"
  };

  return (
    <div className="page">
      <h1>User Information</h1>
      <div className="profile-card">
        <img src={user.image} alt={user.name} className="profile-img" />
        <h2>{user.name}</h2>
        <p><strong>Role:</strong> {user.role}</p>
        <p><strong>Age:</strong> {user.age}</p>
        <p><strong>Date of Birth:</strong> {user.dob}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Phone:</strong> {user.phone}</p>
        <p><strong>Location:</strong> {user.location}</p>
      </div>
    </div>
  );
}

export default UserInfo;
